<template>
    <v-menu
        :close-on-click="true"
        :close-on-content-click="false"
        :return-value="date"
        :style="{width:width+'px'}"
        max-width="290px"
        min-width="290px"
        offset-y
        ref="menu"
        transition="scale-transition"
        v-model="active"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                :value="date"
                :label="label"
                readonly
                outlined
                dense
                hide-details
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
            :day-format="format"
            :locale="locale"
            scrollable
            :value="date"
            @change="onChangeDate"
        />
    </v-menu>
</template>

<script>
import {DateTime} from 'luxon';
import CoreDate from "./CoreDate";

export default {
    name: "AdminDatePicker",
    mixins: [CoreDate],
    props: {
        width: {
            type: Number,
            default: 80
        },
        label: String,
        date: String,
    },

    data() {
        return {
            active: false,
        }
    },

    computed: {
        styleObject() {
            return {
                width: this.width + 'px',
            };
        },
    },

    methods: {
        format(date) {
            return DateTime.fromISO(date).get('day');
        },
        onChangeDate(value) {
            this.$emit('update:date', value)
            this.active = false
        },
    },
}
</script>

<style scoped>
>>> input:read-only, >>> input {
    background-color: transparent !important;
    border: 0 !important;
}
</style>
